define('Google.SiteReviews.View', [
	'Backbone.CompositeView',
	'Backbone',
	'google_sitereviews.tpl'
], function GoogleSiteReviewsView(
	BackboneCompositeView,
	Backbone,
	googleSiteReviewsTpl
) {
	'use strict';

	return Backbone.View.extend({
		template: googleSiteReviewsTpl,
		initialize: function initialize() {
			var self = this;
			this.listenTo(this.model, 'sync', this.render);
			this.on('afterViewRender', function onAfterRender() {
				self.$('.google-sitereviews-slider-container').bxSlider({
					minSlides: 1,
					maxSlides: 4,
					slideWidth: 300,
					infiniteLoop: false,
					slideMargin: 30,
					controls: false,
					auto: false,
					speed: 300,
					pause: 6000,
					pager: false,
					shrinkItems: true
				});
			});
		},
		getContext: function getContext() {
			var store = this.model.get('store');
			var placeId = store && typeof store.get === 'function' ? store.get('googlePlaceId') : '';
			return {
				reviews: this.model.get('reviews') || [],
				reviewsLink: placeId
					? 'https://search.google.com/local/reviews?placeid=' + placeId
					: '',
				isReady: !this.model.isNew() && !!placeId
			};
		}
	});
});
